<template>
  <transition name="el-zoom-in-top">
    <el-dialog title="编辑质检报告" :visible.sync="report.show" width="30%">
      <div style="text-align: left;" v-show="report.show">
        <div slot="header" class="clearfix"></div>
        <div v-show="show">
          <!-- 填写基础信息 -->
          <el-form ref="report" :model="report" label-width="120px" :rules="rules">
            <el-form-item label="质检图片1">
              <el-input v-model="report.quality_field1" placeholder="请输入内容"></el-input>
              <el-image width="300px" v-show="report.quality_field1.length" :preview-src-list="[report.quality_field1]"
                :src="report.quality_field1" alt="图片展开" style="height: 100px;width:auto"/>
            </el-form-item>
            <el-form-item label="质检图片2">
              <el-input v-model="report.quality_field2" placeholder="请输入内容"></el-input>
              <el-image width="300px" v-show="report.quality_field2.length" :preview-src-list="[report.quality_field2]"
                :src="report.quality_field2" alt="图片展开" style="height: 100px;width:auto"/>
            </el-form-item>
            <el-form-item label="质检图片3">
              <el-input v-model="report.quality_field3" placeholder="请输入内容"></el-input>
              <el-image width="300px" v-show="report.quality_field3.length" :preview-src-list="[report.quality_field3]"
                :src="report.quality_field2" alt="图片展开" style="height: 100px;width:auto"/>
            </el-form-item>
          </el-form>
          <div style="text-align: center;">
            <el-button style="margin-top: 12px;" @click="submitadd('report')" type="primary">提交</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </transition>
</template>
<script>
import {
  qualityreports,
  qualityreportsupdate,
  uploadimg,
  downloadimg
} from "@/api/plant";
import { getToken } from '@/utils/auth'
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      options: [
        {
          value: 0,
          label: "红包"
        }
      ],
      //基础数据
      show: true,
      active: 1,
      // 上传图片
      report: {
        show: false,
        id: null,
        quality_reports: '该字段作废',
        quality_field1: '',
        quality_field2: '',
        quality_field3: '',
        quality_field4: '',
        quality_field5: '',
      },
      headers: {
        Token: getToken()
      },
      uploaddata: { folder: "xyq" },
      fileList: [],
      uploadurl:
        process.env.VUE_APP_BASE_API +
        "/api/produce/fileuploader/uploadimg",
      dialogVisible: false,
      dialogImageUrl: null,
      rules: {
        code: [{ required: true, message: "请输入奖品编码", trigger: "blur" }],
        name: [
          { required: true, message: "请输入奖品名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" }
        ],
        value: [
          { required: true, message: "请输入奖励金额", trigger: "blur" },
          { type: "number", message: "必须为数字值" }
        ],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { type: "number", message: "必须为数字值" }
        ]
      }
    };
  },
  mounted() { },
  methods: {
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          // 上传图片

          qualityreportsupdate(this.report).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!"
              });
              this.report.show = false;
              this.resetForm("report");
              this.search();
              this.report.show = false;
            } else {
              this.$message({
                type: "warning",
                message: "修改失败!请检查字段"
              });
            }
          });

        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
    },

  }
};
</script>

<style></style>
